import { cn } from '@april9au/react-common/utils';

import type { CtaLink } from './cta-link';
import { CtaLinkButton } from './cta-link';

/** Heading + one line of copy, a primary button, and a rule-link fallback. Pairs with `StatCard` in a hero's card stack. */
export function AppraisalCard({
  heading,
  description,
  cta,
  callLink,
  className,
}: {
  heading: string;
  description: string;
  cta: CtaLink;
  /** Quiet fallback for someone who'd rather talk than fill in a form. */
  callLink?: CtaLink;
  className?: string;
}) {
  return (
    <div className={cn('card flex flex-1 flex-col gap-4', className)}>
      <p className="text-foreground text-lg">{heading}</p>
      <p className="text-body">{description}</p>
      <CtaLinkButton cta={cta} className="mt-1 self-start" />
      {callLink ? <CtaLinkButton cta={callLink} variant="rule" /> : null}
    </div>
  );
}
